import { PlainButton } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import { useScreenTransitionManager } from "@jugl-web/utils/utils/ScreenTransitionManager";
import { collapsedIconButtonClassName } from "@web-src/modules/client-support/pages/ClientSupportPage/consts";
import { useEmailAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/EmailAccountProvider/useEmailAccount";
import React from "react";
import { VerifyEmailForwardingStep } from "../EmailSetupScreen/components/VerifyEmailForwardingStep";
import { ReactComponent as ArrowLeftIcon } from "./assets/arrow-left.svg";
import { ManageAccountsDrawerScreenToParametersMap } from "../../types";

export const EmailForwardingSetupScreen: React.FC = () => {
  const { transitionTo } =
    useScreenTransitionManager<ManageAccountsDrawerScreenToParametersMap>();
  const { emailAccount } = useEmailAccount();

  if (!emailAccount) {
    return null;
  }

  return (
    <div className="flex h-full justify-center overflow-y-auto bg-grey-100 p-8 max-lg:p-4">
      <div className="flex w-full items-start justify-center gap-4 pr-12 max-lg:pr-0">
        <PlainButton
          className={cx(collapsedIconButtonClassName, "h-8 w-8")}
          onClick={() => transitionTo({ name: "emailAccount" })}
        >
          <ArrowLeftIcon />
        </PlainButton>

        <div className="w-full max-w-[1200px] rounded-2xl border border-solid border-grey-300 bg-white p-8 max-lg:p-5">
          <VerifyEmailForwardingStep forwardingEmail={emailAccount.email} />
        </div>
      </div>
    </div>
  );
};
